import { createContext, useContext } from 'react';
export var CalendarContext = /*#__PURE__*/createContext({
  weeks: []
});
export var useCalendarContext = () => useContext(CalendarContext);
//# sourceMappingURL=CalendarContext.js.map